import {Injectable} from '@angular/core';
import {BehaviorSubject, of, Subject, Subscription} from 'rxjs';
import {distinctUntilChanged, switchMap} from 'rxjs/operators';
import {ProjectListService} from './project-list.service';
import {BusinessLogicListService} from './business-logic-list.service';
import {BusinessLogicModel} from '../../business-logic/business-logic.model';
import {ProjectModel} from '../../project/project.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectBusinessLogicFilterService {

  projectList: BehaviorSubject<Array<any> | null> = new BehaviorSubject<Array<any>>(null);
  businessLogicList: BehaviorSubject<Array<any> | null> = new BehaviorSubject<Array<any>>(null);
  selectedProjectId: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  selectedBusinessLogics: BehaviorSubject<BusinessLogicModel[] | null> = new BehaviorSubject<BusinessLogicModel[] | null>(null);
  selectedBusinessLogicId: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  triggerBusinessLogicUpdate = new Subject<void>();

  subscriptions: Subscription[] = [];

  constructor(
    private projectListService: ProjectListService,
    private businessLogicListService: BusinessLogicListService,
  ) { }

  refreshProjects() {
    this.subscriptions.push(
      this.projectListService.getProjects().subscribe(
        projects => {
          this.projectList.next(projects);
        }
      )
    );
  }

  refreshBusinessLogicList(result: BusinessLogicModel[] | null): void {
    this.businessLogicList.next(result);
  }

  onInit() {
    this.refreshProjects();
    this.subscriptions.push(
      this.selectedProjectId.pipe(
        distinctUntilChanged(),
        switchMap(
          projectId => {
            this.businessLogicList.next(null);
            return projectId !== null ?
              this.businessLogicListService.getBusinessLogics(projectId)
              : of(null);
          }
        )
      ).subscribe(
        (result: BusinessLogicModel[] | null) => {
          this.refreshBusinessLogicList(result);
        }
      )
    );
  }

  onDestroy() {
    this.subscriptions.filter(s => !!s).forEach(s => s.unsubscribe());
  }
}
